import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { selectIsModalOpened } from 'state/selectors';
import { useModal } from 'useCase/modal/useModal';
import { ModalName } from 'features/Modals';
import { Tooltip } from '@web-chat-core/ui-kit';
import { useWaitingRoom } from 'features/AccessRequests/hooks/useWaitingRoom';
import { AddParticipantsIcon, ParticipantButton, ParticipantCounter, WaitingRequestsDot } from './view';

interface IProps {
    count: number;
}

export const ParticipantsCount = observer(({ count }: IProps) => {
    const { t } = useTranslation();
    const { toggleModal } = useModal();
    const isParticipantModalOpen = selectIsModalOpened(ModalName.PARTICIPANTS);
    const { waitingUsers, isCanManageWaitingUsers } = useWaitingRoom();
    const handleToggleParticipants = () => {
        toggleModal(ModalName.PARTICIPANTS);
    };

    return (
        <Tooltip label={isParticipantModalOpen ? '' : t('web_call_participants')}>
            <ParticipantButton active={isParticipantModalOpen} onClick={handleToggleParticipants}>
                <AddParticipantsIcon icon="icAddParticipants" $active={isParticipantModalOpen} />
                <ParticipantCounter>{count}</ParticipantCounter>
                {!isParticipantModalOpen && isCanManageWaitingUsers && waitingUsers.length > 0 && (
                    <WaitingRequestsDot />
                )}
            </ParticipantButton>
        </Tooltip>
    );
});
